export const AcFormatCurrencySeparator = (language) => {
  const numberWithDecimalSeparator = 1.1;
  return Intl.NumberFormat(language)
    .formatToParts(numberWithDecimalSeparator)
    .find(part => part.type === 'decimal')
    .value;
};

export default AcFormatCurrencySeparator;
